import ServiceSelection from './ServiceSelection';
import SelectPicture from './SelectPicture';
import SelectStagingOptions from './aiStagingOrder/SelectStagingOptions';

export const SelectPictureStep = SelectPicture;
export const ServiceSelectionStep = ServiceSelection;
export const SelectStagingOptionsStep = SelectStagingOptions;
